import { apiIsomorphicFetchInvite } from '#/api/invite/apiFetchInvite';
import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import { authSignupRoute } from '#/modules/auth/routing/auth.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';
import { getAppRouteSearchParams } from '#/routing/utils/getAppRouteSearchParams';

import { AuthSignupPage } from './AuthSignupPage';

export async function loader({
  request,
  url,
  context,
}: HorizonAppRouteLoaderArgs<typeof authSignupRoute>) {
  const { invite: inviteId } = getAppRouteSearchParams({
    url,
    route: authSignupRoute,
  });

  const [inviteData] = await Promise.all([
    inviteId
      ? apiIsomorphicFetchInvite({ request, context })(inviteId)
      : Promise.resolve(null),
    AuthSignupPage as unknown as Promise<unknown>,
  ]);

  return { invite: inviteData ? inviteData.invite : null };
}

export default function AuthSignupHorizonRoute({
  loaderData: { invite },
}: HorizonAppRouteComponentProps<typeof loader>) {
  const { i18n } = useI18n();

  return (
    <RouteModule title={i18n('Sign Up')}>
      <AuthSignupPage invite={invite} />
    </RouteModule>
  );
}
